import {
  CREATE_SITE_CONFIGURATION,
  DELETE_SITE_CONFIGURATION,
  EDIT_SITE_CONFIGURATION,
  RECEIVE_SITE_CONFIGURATIONS,
  REQUEST_SITE_CONFIGURATION,
} from '@sophocles/entities/SiteConfiguration/siteConfigurationActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_SITE_CONFIGURATIONS: // Read
      return state.merge(action.siteConfigurations);
    case DELETE_SITE_CONFIGURATION: // Delete
      return state.delete(action.siteConfigurations);
    case EDIT_SITE_CONFIGURATION: // Update
    case CREATE_SITE_CONFIGURATION: // Create
    case REQUEST_SITE_CONFIGURATION:
    default:
      return state;
  }
}

export function siteConfigurationReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_SITE_CONFIGURATION:
    case DELETE_SITE_CONFIGURATION:
    case RECEIVE_SITE_CONFIGURATIONS:
    case EDIT_SITE_CONFIGURATION:
    case REQUEST_SITE_CONFIGURATION:
      return getState(state, action);
    default:
      return state;
  }
}
